import solver from 'solver-utilities';
import { history } from './helpers.js';

/**
 * Sets markup of collection returned from string of markup
 * @param { string } string - DOM string
 */
const setCollectionMarkup = function (string) {
	let markup = new DOMParser();
	markup = markup.parseFromString(string, 'text/html');

	if (!markup.querySelector('[data-filter-toggle="list-sortby"] span')) return;

	const sortText = markup.querySelector('[data-filter-toggle="list-sortby"] span').innerText;
	markup = markup.querySelector('[data-collection-items]');

	const container = document.querySelector('[data-collection-items]');
	if (container) container.innerHTML = markup.innerHTML;

	const sortBtn = document.querySelector('[data-filter-toggle="list-sortby"] span');
	if (sortBtn) sortBtn.innerText = sortText;
};

/**
 * Get collection markup from http request
 */
const getCollectionMarkup = async function () {
	try {
		const { pathname, search } = window.location;
		let endpoint = pathname;
		if (search && search != '') endpoint = pathname + search;

		let req = await fetch(endpoint);

		if (!req || (req && !req.ok)) {
			return;
		}

		req = await req.text();

		if (search) setCollectionMarkup(req);
	} catch (error) {
		console.error(error);
	}
};

/**
 * Sets collection min grid height based on desktop filters
 */
export const setcollectionGridHeight = function () {
	const root = document.querySelector(':root');
	const collectionMinHeight = solver.frontend.getCSSVariable('--collection-grid-min-height');
	const filters = document.querySelector('[data-el="collection-filters-desktop"]');
	if (!filters) return;

	const bounds = filters.getBoundingClientRect();

	if (window.innerWidth > 1100) {
		root.style.setProperty('--collection-grid-min-height', bounds.height + 'px');
	} else {
		root.style.setProperty('--collection-grid-min-height', 'auto');
	}
};

export const collection = async function () {
	if (!window.Solver || (window.Solver && !window.Solver.collection) || window.Solver.product) {
		return null;
	}

	const pagination = document.querySelector('[data-pagination-limit] ul');
	if (pagination) pagination.remove();

	const markup = await getCollectionMarkup();
	if (!markup) return null;

	setcollectionGridHeight();
};
